import { ExternalUploaderSettings } from '@ff-os/shared-json/ExternalUploaderSettings';
import { createAuthorizationHeader } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { actions as externalUploadActions } from '../../slices/externalUploadersSlice';
import { GlobalState } from '../../slices/globalSlice';
import { AppThunkApi, PdpState } from '../../store';
import { withAuthorization } from '../authorization/withAuthorization';
import { createAsyncAppThunk } from '../createAsyncAppThunk';

export const requestExternalUploader = createAsyncAppThunk<ExternalUploaderSettings<any>, void>(
    'externalUpload/request',
    async (settings, thunkApi: AppThunkApi) => {

        const response = await withAuthorization(async (state: PdpState) => {
            return fetch(urls.createExternalUploader, formatRequest(state, settings));
        }, thunkApi);

        if (response.ok) {

            const externalUploader = await response.json();

            thunkApi.dispatch(externalUploadActions.add({
                id: externalUploader.id,
                settings: externalUploader.settings,
                url: externalUploader.url,
                createdOn: externalUploader.createdOn,
                expiresOn: externalUploader.expiresOn,
                imageCount: 0
            }));
        } else {
            throw new Error(`Error while creating external uploader`);
        }
    });

const formatRequest = (state: PdpState, settings: ExternalUploaderSettings<any>) => ({
    method: 'POST',
    mode: 'cors' as RequestMode,
    headers: {
        ...createAuthorizationHeader(state.auth.jwt!),
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(withLanguage(settings, state.global.language))
});

const withLanguage = (settings: ExternalUploaderSettings<any>, language: GlobalState['language']) => ({
    settings: {
        ...settings,
        language: language
    }
});